import Layout from "../../../../src/components/Layout";
import * as React from 'react';
export default {
  Layout,
  React
};